import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { 
  ArrowLeft, 
  MapPin, 
  Calendar, 
  Users, 
  Bed, 
  Wifi, 
  Car, 
  Coffee,
  Phone,
  Mail,
  Euro,
  Clock,
  CheckCircle,
  AlertCircle,
  Star,
  Camera,
  FileText,
  MessageSquare,
  Settings,
  Edit,
  Trash2,
  Plus,
  DollarSign,
  CreditCard,
  Receipt,
  User,
  Home,
  Utensils,
  Anchor
} from 'lucide-react';

const ReservationDetail = ({ reservationId, onBack }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [showAddService, setShowAddService] = useState(false);
  const [planningView, setPlanningView] = useState('detailed'); // 'detailed' ou 'week'
  const [showAddEventModal, setShowAddEventModal] = useState(false);
  const [newEvent, setNewEvent] = useState({
    date: '',
    time: '',
    endTime: '',
    name: '',
    description: '',
    provider: '',
    price: '',
    status: 'pending',
    type: 'activity'
  });

  // Données détaillées de la réservation (simulées)
  const reservationData = {
    id: 'PRV2591',
    status: 'confirmed',
    statusLabel: 'Confirmée',
    clientInfo: {
      name: 'Nicolas Beaumont',
      email: 'nicolas.beaumont@email.com',
      phone: '+33 6 12 34 56 78',
      nationality: 'Française',
      type: 'Nouveau Client',
      vipLevel: 'Gold',
      initials: 'NB',
      previousStays: 0,
      totalSpent: 0,
      preferences: ['Suite Master', 'Yoga matinal', 'Cuisine végétarienne', 'Wifi haute vitesse']
    },
    property: {
      name: 'Villa Celestial',
      type: 'Villa Premium',
      location: 'Mykonos, Grèce',
      address: 'Agios Lazaros Beach, Mykonos 84600',
      coordinates: '37.4467° N, 25.3289° E',
      capacity: 12,
      bedrooms: 6,
      bathrooms: 8,
      amenities: ['Piscine privée', 'Chef privé', 'Service housekeeping', 'Wifi', 'Parking', 'Sécurité 24h'],
      dailyRate: 25000,
      images: ['villa1.jpg', 'villa2.jpg', 'villa3.jpg']
    },
    booking: {
      checkIn: '2025-07-20',
      checkOut: '2025-07-27',
      nights: 7,
      guests: 8,
      children: 2,
      totalAmount: 175000,
      baseAmount: 150000,
      taxes: 15000,
      services: 10000,
      deposit: 87500,
      balance: 87500,
      currency: 'EUR',
      createdDate: '2024-09-10',
      confirmedDate: '2024-09-12',
      paymentStatus: 'deposit_paid'
    },
    timeline: [
      {
        date: '2024-09-10 14:30',
        action: 'Demande créée',
        status: 'info',
        description: 'Nouvelle demande de réservation reçue',
        user: 'System'
      },
      {
        date: '2024-09-10 16:45',
        action: 'Devis envoyé',
        status: 'success',
        description: 'Devis détaillé envoyé au client',
        user: 'Sarah Martin'
      },
      {
        date: '2024-09-12 09:15',
        action: 'Devis accepté',
        status: 'success',
        description: 'Client a accepté les conditions',
        user: 'Nicolas Beaumont'
      },
      {
        date: '2024-09-12 10:00',
        action: 'Dépôt reçu',
        status: 'success',
        description: 'Dépôt de 50% reçu (€87,500)',
        user: 'Finance'
      },
      {
        date: '2024-09-12 10:30',
        action: 'Réservation confirmée',
        status: 'success',
        description: 'Villa bloquée et confirmation envoyée',
        user: 'Sarah Martin'
      }
    ],
    conciergeServices: [
      {
        id: 'CONC001',
        name: 'Transfert privé aéroport',
        description: 'Mercedes Classe S avec chauffeur',
        status: 'confirmed',
        date: '2025-07-20',
        time: '14:00',
        price: 150,
        provider: 'Elite Transport Mykonos'
      },
      {
        id: 'CONC002',
        name: 'Chef privé - Dîner de bienvenue',
        description: 'Menu dégustation méditerranéen pour 8 personnes',
        status: 'pending',
        date: '2025-07-20',
        time: '20:00',
        price: 800,
        provider: 'Chef Dimitri'
      },
      {
        id: 'CONC003',
        name: 'Excursion en yacht privé',
        description: 'Journée complète avec déjeuner - Delos & Rhenia',
        status: 'confirmed',
        date: '2025-07-22',
        time: '09:00',
        price: 2500,
        provider: 'Mykonos Yacht Club'
      },
      {
        id: 'CONC004',
        name: 'Massage couple au coucher du soleil',
        description: 'Massage relaxant en terrasse avec vue mer',
        status: 'requested',
        date: '2025-07-24',
        time: '18:30',
        price: 350,
        provider: 'Serenity Spa'
      }
    ],
    payments: [
      {
        id: 'PAY001',
        date: '2024-09-12',
        description: 'Dépôt de réservation (50%)',
        amount: 87500,
        status: 'completed',
        method: 'Virement bancaire',
        reference: 'TRF-20240912-001'
      },
      {
        id: 'PAY002',
        date: '2025-06-20',
        description: 'Solde final (50%)',
        amount: 87500,
        status: 'pending',
        method: 'A déterminer',
        reference: 'Échéance: 30 jours avant arrivée'
      }
    ],
    documents: [
      { name: 'Contrat de location', type: 'pdf', status: 'signed', date: '2024-09-12' },
      { name: 'Conditions générales', type: 'pdf', status: 'signed', date: '2024-09-12' },
      { name: 'Assurance annulation', type: 'pdf', status: 'pending', date: null },
      { name: 'Fiche client', type: 'pdf', status: 'completed', date: '2024-09-10' }
    ],
    notes: [
      {
        id: 1,
        author: 'Sarah Martin',
        date: '2024-09-12 11:15',
        content: 'Client très professionnel, demande spéciale pour arrangement floral à l\'arrivée. Prévoir orchidées blanches.',
        type: 'info'
      },
      {
        id: 2,
        author: 'Marc Dubois',
        date: '2024-09-11 14:30',
        content: 'Attention : client végétarien strict + un invité allergique aux fruits de mer. Informer le chef.',
        type: 'warning'
      }
    ]
  };

  const getStatusColor = (status) => {
    const colors = {
      'confirmed': 'bg-green-100 text-green-800',
      'pending': 'bg-yellow-100 text-yellow-800',
      'requested': 'bg-blue-100 text-blue-800',
      'cancelled': 'bg-red-100 text-red-800',
      'completed': 'bg-green-100 text-green-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Button variant="ghost" onClick={onBack} className="p-2">
                <ArrowLeft className="w-5 h-5" />
              </Button>
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">
                  Réservation {reservationData.id}
                </h1>
                <p className="text-sm text-gray-500">
                  {reservationData.property.name} • {reservationData.clientInfo.name}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <Badge className={getStatusColor(reservationData.status)}>
                {reservationData.statusLabel}
              </Badge>
              <Button variant="outline" size="sm">
                <Edit className="w-4 h-4 mr-2" />
                Modifier
              </Button>
              <Button size="sm" className="bg-yellow-600 hover:bg-yellow-700 text-black">
                <MessageSquare className="w-4 h-4 mr-2" />
                Contacter client
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Info Bar */}
      <div className="bg-white border-b px-6 py-4">
        <div className="grid grid-cols-5 gap-6">
          <div className="flex items-center space-x-3">
            <Calendar className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">{formatDate(reservationData.booking.checkIn)} - {formatDate(reservationData.booking.checkOut)}</p>
              <p className="text-xs text-gray-500">{reservationData.booking.nights} nuits</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Users className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">{reservationData.booking.guests} invités</p>
              <p className="text-xs text-gray-500">{reservationData.booking.children} enfants</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Euro className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">€{reservationData.booking.totalAmount.toLocaleString()}</p>
              <p className="text-xs text-gray-500">Total</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <CreditCard className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">€{reservationData.booking.deposit.toLocaleString()}</p>
              <p className="text-xs text-gray-500">Dépôt payé</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Clock className="w-5 h-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">{Math.ceil((new Date(reservationData.booking.checkIn) - new Date()) / (1000 * 60 * 60 * 24))} jours</p>
              <p className="text-xs text-gray-500">Avant arrivée</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="overview">Vue d'ensemble</TabsTrigger>
            <TabsTrigger value="property">Propriété</TabsTrigger>
            <TabsTrigger value="client">Client</TabsTrigger>
            <TabsTrigger value="planning">Planning</TabsTrigger>
            <TabsTrigger value="concierge">Conciergerie</TabsTrigger>
            <TabsTrigger value="payments">Paiements</TabsTrigger>
            <TabsTrigger value="timeline">Timeline</TabsTrigger>
            <TabsTrigger value="documents">Documents</TabsTrigger>
          </TabsList>

          {/* Vue d'ensemble */}
          <TabsContent value="overview">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Résumé de la réservation */}
              <div className="lg:col-span-2 space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center space-x-2">
                      <Home className="w-5 h-5" />
                      <span>Détails de la réservation</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-500">Propriété</p>
                        <p className="font-medium">{reservationData.property.name}</p>
                        <p className="text-sm text-gray-600">{reservationData.property.location}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Période</p>
                        <p className="font-medium">{formatDate(reservationData.booking.checkIn)} - {formatDate(reservationData.booking.checkOut)}</p>
                        <p className="text-sm text-gray-600">{reservationData.booking.nights} nuits</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Capacité</p>
                        <p className="font-medium">{reservationData.booking.guests} invités</p>
                        <p className="text-sm text-gray-600">{reservationData.booking.children} enfants inclus</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Tarif journalier</p>
                        <p className="font-medium">€{reservationData.property.dailyRate.toLocaleString()}</p>
                        <p className="text-sm text-gray-600">par nuit</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Services de conciergerie - Aperçu */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <Star className="w-5 h-5" />
                        <span>Services de conciergerie</span>
                      </div>
                      <Button variant="outline" size="sm" onClick={() => setActiveTab('concierge')}>
                        Voir tout
                      </Button>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      {reservationData.conciergeServices.slice(0, 3).map(service => (
                        <div key={service.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                          <div className="flex-1">
                            <p className="font-medium text-sm">{service.name}</p>
                            <p className="text-xs text-gray-600">{service.date} à {service.time}</p>
                          </div>
                          <div className="text-right">
                            <Badge className={getStatusColor(service.status)}>{service.status}</Badge>
                            <p className="text-sm font-medium mt-1">€{service.price}</p>
                          </div>
                        </div>
                      ))}
                      {reservationData.conciergeServices.length > 3 && (
                        <p className="text-sm text-gray-500 text-center">
                          +{reservationData.conciergeServices.length - 3} autres services
                        </p>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Sidebar */}
              <div className="space-y-6">
                {/* Client Info */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center space-x-2">
                      <User className="w-5 h-5" />
                      <span>Informations client</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center text-white font-semibold">
                        {reservationData.clientInfo.initials}
                      </div>
                      <div>
                        <p className="font-medium">{reservationData.clientInfo.name}</p>
                        <Badge variant="outline">{reservationData.clientInfo.vipLevel}</Badge>
                      </div>
                    </div>
                    <div className="space-y-2 text-sm">
                      <div className="flex items-center space-x-2">
                        <Mail className="w-4 h-4 text-gray-400" />
                        <span>{reservationData.clientInfo.email}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Phone className="w-4 h-4 text-gray-400" />
                        <span>{reservationData.clientInfo.phone}</span>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Facturation */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center space-x-2">
                      <Receipt className="w-5 h-5" />
                      <span>Facturation</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex justify-between text-sm">
                        <span>Séjour (7 nuits)</span>
                        <span>€{reservationData.booking.baseAmount.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span>Services</span>
                        <span>€{reservationData.booking.services.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span>Taxes & frais</span>
                        <span>€{reservationData.booking.taxes.toLocaleString()}</span>
                      </div>
                      <div className="border-t pt-2">
                        <div className="flex justify-between font-semibold">
                          <span>Total</span>
                          <span>€{reservationData.booking.totalAmount.toLocaleString()}</span>
                        </div>
                      </div>
                      <div className="mt-4 space-y-2">
                        <div className="flex justify-between text-sm">
                          <span className="text-green-600">✓ Dépôt payé</span>
                          <span className="text-green-600">€{reservationData.booking.deposit.toLocaleString()}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-orange-600">Solde restant</span>
                          <span className="text-orange-600">€{reservationData.booking.balance.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Actions rapides */}
                <Card>
                  <CardHeader>
                    <CardTitle>Actions rapides</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      <Button variant="outline" size="sm" className="w-full justify-start">
                        <MessageSquare className="w-4 h-4 mr-2" />
                        Envoyer message
                      </Button>
                      <Button variant="outline" size="sm" className="w-full justify-start">
                        <FileText className="w-4 h-4 mr-2" />
                        Générer facture
                      </Button>
                      <Button variant="outline" size="sm" className="w-full justify-start">
                        <Calendar className="w-4 h-4 mr-2" />
                        Planifier rappel
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </TabsContent>

          {/* Propriété */}
          <TabsContent value="property">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <Card>
                <CardHeader>
                  <CardTitle>Informations de la propriété</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-lg font-semibold">{reservationData.property.name}</h3>
                      <p className="text-gray-600">{reservationData.property.type}</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <MapPin className="w-4 h-4 mt-1 text-gray-400" />
                      <div>
                        <p className="text-sm">{reservationData.property.address}</p>
                        <p className="text-xs text-gray-500">{reservationData.property.coordinates}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4 pt-4 border-t">
                      <div className="text-center">
                        <Users className="w-6 h-6 mx-auto mb-1 text-gray-400" />
                        <p className="text-lg font-semibold">{reservationData.property.capacity}</p>
                        <p className="text-xs text-gray-500">Invités max</p>
                      </div>
                      <div className="text-center">
                        <Bed className="w-6 h-6 mx-auto mb-1 text-gray-400" />
                        <p className="text-lg font-semibold">{reservationData.property.bedrooms}</p>
                        <p className="text-xs text-gray-500">Chambres</p>
                      </div>
                      <div className="text-center">
                        <Home className="w-6 h-6 mx-auto mb-1 text-gray-400" />
                        <p className="text-lg font-semibold">{reservationData.property.bathrooms}</p>
                        <p className="text-xs text-gray-500">Salles de bain</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Équipements & Services</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-2 gap-3">
                    {reservationData.property.amenities.map((amenity, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        <span className="text-sm">{amenity}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Client */}
          <TabsContent value="client">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <Card>
                <CardHeader>
                  <CardTitle>Profil client</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center text-white text-xl font-semibold">
                        {reservationData.clientInfo.initials}
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold">{reservationData.clientInfo.name}</h3>
                        <Badge variant="outline">{reservationData.clientInfo.vipLevel}</Badge>
                        <p className="text-sm text-gray-600 mt-1">{reservationData.clientInfo.type}</p>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 pt-4 border-t">
                      <div>
                        <p className="text-sm text-gray-500">Email</p>
                        <p className="font-medium">{reservationData.clientInfo.email}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Téléphone</p>
                        <p className="font-medium">{reservationData.clientInfo.phone}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Nationalité</p>
                        <p className="font-medium">{reservationData.clientInfo.nationality}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Séjours précédents</p>
                        <p className="font-medium">{reservationData.clientInfo.previousStays}</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Préférences client</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    {reservationData.clientInfo.preferences.map((pref, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Star className="w-4 h-4 text-yellow-500" />
                        <span className="text-sm">{pref}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Planning */}
          <TabsContent value="planning">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Planning détaillé du séjour</h3>
                <div className="flex gap-2">
                  <Button 
                    variant={planningView === 'week' ? 'default' : 'outline'} 
                    size="sm"
                    onClick={() => setPlanningView(planningView === 'week' ? 'detailed' : 'week')}
                  >
                    <Calendar className="w-4 h-4 mr-2" />
                    {planningView === 'week' ? 'Vue détaillée' : 'Vue semaine'}
                  </Button>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => setShowAddEventModal(true)}
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Ajouter événement
                  </Button>
                </div>
              </div>

              {/* Vue d'ensemble des dates */}
              <Card className="bg-gradient-to-r from-blue-50 to-blue-100">
                <CardContent className="p-6">
                  <div className="grid grid-cols-3 gap-6">
                    <div className="text-center">
                      <p className="text-sm text-gray-600 mb-1">Arrivée</p>
                      <p className="text-xl font-semibold text-blue-700">{formatDate(reservationData.booking.checkIn)}</p>
                      <p className="text-sm text-gray-500">Dimanche • 15:00</p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm text-gray-600 mb-1">Séjour</p>
                      <p className="text-xl font-semibold text-blue-700">{reservationData.booking.nights} nuits</p>
                      <p className="text-sm text-gray-500">20-27 Juillet 2025</p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm text-gray-600 mb-1">Départ</p>
                      <p className="text-xl font-semibold text-blue-700">{formatDate(reservationData.booking.checkOut)}</p>
                      <p className="text-sm text-gray-500">Dimanche • 11:00</p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Vue semaine condensée */}
              {planningView === 'week' && (
                <Card>
                  <CardContent className="p-6">
                    <div className="grid grid-cols-7 gap-2">
                      {/* En-têtes des jours */}
                      {['Dim 20', 'Lun 21', 'Mar 22', 'Mer 23', 'Jeu 24', 'Ven 25', 'Sam 26'].map((day, index) => (
                        <div key={index} className="text-center border-b pb-2 mb-3">
                          <h4 className="font-medium text-sm">{day}</h4>
                          <p className="text-xs text-gray-500">Juillet</p>
                        </div>
                      ))}
                      
                      {/* Jour 1 - Arrivée */}
                      <div className="space-y-1">
                        <div className="bg-green-100 text-green-800 text-xs p-2 rounded">
                          <div className="font-medium">Arrivée</div>
                          <div className="text-xs">15:00</div>
                        </div>
                        <div className="bg-blue-100 text-blue-800 text-xs p-2 rounded">
                          <div className="font-medium">Transfert</div>
                          <div className="text-xs">14:00</div>
                        </div>
                        <div className="bg-orange-100 text-orange-800 text-xs p-2 rounded">
                          <div className="font-medium">Dîner</div>
                          <div className="text-xs">20:00</div>
                        </div>
                      </div>

                      {/* Jour 2 */}
                      <div className="space-y-1">
                        <div className="bg-yellow-100 text-yellow-800 text-xs p-2 rounded">
                          <div className="font-medium">P.déj</div>
                          <div className="text-xs">08:00</div>
                        </div>
                        <div className="bg-gray-100 text-gray-800 text-xs p-2 rounded">
                          <div className="font-medium">Ménage</div>
                          <div className="text-xs">10:00</div>
                        </div>
                        <div className="bg-blue-100 text-blue-800 text-xs p-2 rounded">
                          <div className="font-medium">Libre</div>
                          <div className="text-xs">14:00</div>
                        </div>
                      </div>

                      {/* Jour 3 - Excursion */}
                      <div className="space-y-1">
                        <div className="bg-blue-200 text-blue-900 text-xs p-2 rounded">
                          <div className="font-medium">Yacht</div>
                          <div className="text-xs">09:00</div>
                        </div>
                        <div className="bg-blue-200 text-blue-900 text-xs p-2 rounded">
                          <div className="font-medium">Delos</div>
                          <div className="text-xs">Journée</div>
                        </div>
                        <div className="bg-purple-100 text-purple-800 text-xs p-2 rounded">
                          <div className="font-medium">Retour</div>
                          <div className="text-xs">18:00</div>
                        </div>
                      </div>

                      {/* Jour 4 - Wellness */}
                      <div className="space-y-1">
                        <div className="bg-yellow-100 text-yellow-800 text-xs p-2 rounded">
                          <div className="font-medium">P.déj</div>
                          <div className="text-xs">09:00</div>
                        </div>
                        <div className="bg-blue-100 text-blue-800 text-xs p-2 rounded">
                          <div className="font-medium">Piscine</div>
                          <div className="text-xs">11:00</div>
                        </div>
                        <div className="bg-pink-100 text-pink-800 text-xs p-2 rounded">
                          <div className="font-medium">Massage</div>
                          <div className="text-xs">18:30</div>
                        </div>
                      </div>

                      {/* Jour 5 */}
                      <div className="space-y-1">
                        <div className="bg-yellow-100 text-yellow-800 text-xs p-2 rounded">
                          <div className="font-medium">P.déj</div>
                          <div className="text-xs">08:30</div>
                        </div>
                        <div className="bg-green-100 text-green-800 text-xs p-2 rounded">
                          <div className="font-medium">Exploration</div>
                          <div className="text-xs">10:00</div>
                        </div>
                        <div className="bg-purple-100 text-purple-800 text-xs p-2 rounded">
                          <div className="font-medium">Shopping</div>
                          <div className="text-xs">15:00</div>
                        </div>
                      </div>

                      {/* Jour 6 */}
                      <div className="space-y-1">
                        <div className="bg-yellow-100 text-yellow-800 text-xs p-2 rounded">
                          <div className="font-medium">P.déj</div>
                          <div className="text-xs">09:00</div>
                        </div>
                        <div className="bg-orange-100 text-orange-800 text-xs p-2 rounded">
                          <div className="font-medium">Beach Club</div>
                          <div className="text-xs">11:00</div>
                        </div>
                        <div className="bg-red-100 text-red-800 text-xs p-2 rounded">
                          <div className="font-medium">Dernière soirée</div>
                          <div className="text-xs">19:00</div>
                        </div>
                      </div>

                      {/* Jour 7 - Départ */}
                      <div className="space-y-1">
                        <div className="bg-yellow-100 text-yellow-800 text-xs p-2 rounded">
                          <div className="font-medium">P.déj</div>
                          <div className="text-xs">08:00</div>
                        </div>
                        <div className="bg-red-200 text-red-900 text-xs p-2 rounded">
                          <div className="font-medium">Check-out</div>
                          <div className="text-xs">11:00</div>
                        </div>
                        <div className="bg-gray-200 text-gray-900 text-xs p-2 rounded">
                          <div className="font-medium">Transfert</div>
                          <div className="text-xs">12:00</div>
                        </div>
                      </div>
                    </div>

                    {/* Légende */}
                    <div className="mt-6 pt-4 border-t">
                      <h4 className="text-sm font-medium mb-3">Légende</h4>
                      <div className="grid grid-cols-4 gap-4 text-xs">
                        <div className="flex items-center space-x-2">
                          <div className="w-3 h-3 bg-green-100 rounded"></div>
                          <span>Arrivée/Services</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-3 h-3 bg-blue-100 rounded"></div>
                          <span>Activités/Libre</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-3 h-3 bg-orange-100 rounded"></div>
                          <span>Repas/Restauration</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-3 h-3 bg-pink-100 rounded"></div>
                          <span>Wellness/Spa</span>
                        </div>
                      </div>
                    </div>

                    {/* Statistiques de la semaine */}
                    <div className="mt-6 pt-4 border-t">
                      <div className="grid grid-cols-4 gap-4">
                        <div className="text-center">
                          <div className="text-lg font-semibold text-blue-700">14</div>
                          <div className="text-xs text-gray-500">Services prévus</div>
                        </div>
                        <div className="text-center">
                          <div className="text-lg font-semibold text-green-700">11</div>
                          <div className="text-xs text-gray-500">Confirmés</div>
                        </div>
                        <div className="text-center">
                          <div className="text-lg font-semibold text-yellow-700">2</div>
                          <div className="text-xs text-gray-500">En attente</div>
                        </div>
                        <div className="text-center">
                          <div className="text-lg font-semibold text-blue-700">1</div>
                          <div className="text-xs text-gray-500">Demandé</div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Planning détaillé jour par jour */}
              {planningView === 'detailed' && (
                <div className="space-y-4">
                {/* Jour 1 - Arrivée */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-blue-600" />
                        <span>Dimanche 20 Juillet - Jour d'arrivée</span>
                      </div>
                      <Badge className="bg-green-100 text-green-800">Arrivée</Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                        <div className="text-sm font-medium text-blue-700 min-w-16">14:00</div>
                        <Car className="w-4 h-4 text-blue-600" />
                        <div className="flex-1">
                          <p className="font-medium">Transfert aéroport → Villa</p>
                          <p className="text-sm text-gray-600">Mercedes Classe S • Elite Transport</p>
                        </div>
                        <Badge className="bg-green-100 text-green-800">Confirmé</Badge>
                      </div>
                      
                      <div className="flex items-center space-x-4 p-3 bg-yellow-50 rounded-lg">
                        <div className="text-sm font-medium text-yellow-700 min-w-16">15:00</div>
                        <Home className="w-4 h-4 text-yellow-600" />
                        <div className="flex-1">
                          <p className="font-medium">Check-in & Accueil villa</p>
                          <p className="text-sm text-gray-600">Tour de la propriété • Remise des clés</p>
                        </div>
                        <Badge className="bg-blue-100 text-blue-800">Villa</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-purple-50 rounded-lg">
                        <div className="text-sm font-medium text-purple-700 min-w-16">17:00</div>
                        <Coffee className="w-4 h-4 text-purple-600" />
                        <div className="flex-1">
                          <p className="font-medium">Accueil avec rafraîchissements</p>
                          <p className="text-sm text-gray-600">Champagne de bienvenue • Fruits frais</p>
                        </div>
                        <Badge className="bg-purple-100 text-purple-800">Courtesy</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-orange-50 rounded-lg">
                        <div className="text-sm font-medium text-orange-700 min-w-16">20:00</div>
                        <Utensils className="w-4 h-4 text-orange-600" />
                        <div className="flex-1">
                          <p className="font-medium">Dîner de bienvenue</p>
                          <p className="text-sm text-gray-600">Menu méditerranéen • Chef Dimitri</p>
                        </div>
                        <Badge className="bg-yellow-100 text-yellow-800">En attente</Badge>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Jour 2 */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-blue-600" />
                        <span>Lundi 21 Juillet</span>
                      </div>
                      <Badge className="bg-blue-100 text-blue-800">Séjour</Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
                        <div className="text-sm font-medium text-green-700 min-w-16">08:00</div>
                        <Coffee className="w-4 h-4 text-green-600" />
                        <div className="flex-1">
                          <p className="font-medium">Petit-déjeuner en terrasse</p>
                          <p className="text-sm text-gray-600">Service continental • Vue mer</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Inclus</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
                        <div className="text-sm font-medium text-gray-700 min-w-16">10:00</div>
                        <Settings className="w-4 h-4 text-gray-600" />
                        <div className="flex-1">
                          <p className="font-medium">Ménage matinal</p>
                          <p className="text-sm text-gray-600">Nettoyage & préparation • 2h</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Villa</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                        <div className="text-sm font-medium text-blue-700 min-w-16">14:00</div>
                        <Users className="w-4 h-4 text-blue-600" />
                        <div className="flex-1">
                          <p className="font-medium">Temps libre</p>
                          <p className="text-sm text-gray-600">Piscine • Détente</p>
                        </div>
                        <Badge className="bg-blue-100 text-blue-800">Libre</Badge>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Jour 3 - Excursion yacht */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-blue-600" />
                        <span>Mardi 22 Juillet</span>
                      </div>
                      <Badge className="bg-blue-100 text-blue-800">Excursion</Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
                        <div className="text-sm font-medium text-green-700 min-w-16">08:30</div>
                        <Coffee className="w-4 h-4 text-green-600" />
                        <div className="flex-1">
                          <p className="font-medium">Petit-déjeuner léger</p>
                          <p className="text-sm text-gray-600">Avant excursion</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Inclus</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                        <div className="text-sm font-medium text-blue-700 min-w-16">09:00</div>
                        <Anchor className="w-4 h-4 text-blue-600" />
                        <div className="flex-1">
                          <p className="font-medium">Excursion yacht privé</p>
                          <p className="text-sm text-gray-600">Delos & Rhenia • Mykonos Yacht Club • Déjeuner inclus</p>
                        </div>
                        <Badge className="bg-green-100 text-green-800">Confirmé</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-orange-50 rounded-lg">
                        <div className="text-sm font-medium text-orange-700 min-w-16">18:00</div>
                        <Home className="w-4 h-4 text-orange-600" />
                        <div className="flex-1">
                          <p className="font-medium">Retour villa</p>
                          <p className="text-sm text-gray-600">Transfert depuis port</p>
                        </div>
                        <Badge className="bg-blue-100 text-blue-800">Transport</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-purple-50 rounded-lg">
                        <div className="text-sm font-medium text-purple-700 min-w-16">20:30</div>
                        <Star className="w-4 h-4 text-purple-600" />
                        <div className="flex-1">
                          <p className="font-medium">Dîner libre</p>
                          <p className="text-sm text-gray-600">Recommandations restaurants • Réservations possibles</p>
                        </div>
                        <Badge className="bg-purple-100 text-purple-800">Libre</Badge>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Jour 4 - Wellness */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-blue-600" />
                        <span>Mercredi 23 Juillet</span>
                      </div>
                      <Badge className="bg-purple-100 text-purple-800">Wellness</Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-4 p-3 bg-orange-50 rounded-lg">
                        <div className="text-sm font-medium text-orange-700 min-w-16">09:00</div>
                        <Coffee className="w-4 h-4 text-orange-600" />
                        <div className="flex-1">
                          <p className="font-medium">Petit-déjeuner tardif</p>
                          <p className="text-sm text-gray-600">Détente après excursion</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Inclus</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                        <div className="text-sm font-medium text-blue-700 min-w-16">11:00</div>
                        <Users className="w-4 h-4 text-blue-600" />
                        <div className="flex-1">
                          <p className="font-medium">Temps libre piscine</p>
                          <p className="text-sm text-gray-600">Relaxation • Lecture</p>
                        </div>
                        <Badge className="bg-blue-100 text-blue-800">Libre</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-pink-50 rounded-lg">
                        <div className="text-sm font-medium text-pink-700 min-w-16">18:30</div>
                        <Star className="w-4 h-4 text-pink-600" />
                        <div className="flex-1">
                          <p className="font-medium">Massage couple coucher de soleil</p>
                          <p className="text-sm text-gray-600">Terrasse avec vue mer • Serenity Spa</p>
                        </div>
                        <Badge className="bg-yellow-100 text-yellow-800">Demandé</Badge>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Résumé des autres jours */}
                <Card className="bg-gray-50">
                  <CardContent className="p-4">
                    <div className="grid grid-cols-3 gap-4 text-center">
                      <div>
                        <p className="font-medium text-gray-700">Jeudi 24 Juillet</p>
                        <p className="text-sm text-gray-600">Exploration île • Shopping</p>
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">Vendredi 25 Juillet</p>
                        <p className="text-sm text-gray-600">Beach club • Détente</p>
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">Samedi 26 Juillet</p>
                        <p className="text-sm text-gray-600">Dernière soirée • Packing</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Jour de départ */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-red-600" />
                        <span>Dimanche 27 Juillet - Départ</span>
                      </div>
                      <Badge className="bg-red-100 text-red-800">Départ</Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-4 p-3 bg-orange-50 rounded-lg">
                        <div className="text-sm font-medium text-orange-700 min-w-16">08:00</div>
                        <Coffee className="w-4 h-4 text-orange-600" />
                        <div className="flex-1">
                          <p className="font-medium">Petit-déjeuner de départ</p>
                          <p className="text-sm text-gray-600">Derniers moments</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Inclus</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
                        <div className="text-sm font-medium text-gray-700 min-w-16">10:00</div>
                        <Settings className="w-4 h-4 text-gray-600" />
                        <div className="flex-1">
                          <p className="font-medium">Préparation bagages</p>
                          <p className="text-sm text-gray-600">Assistance équipe villa</p>
                        </div>
                        <Badge className="bg-gray-100 text-gray-800">Service</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-red-50 rounded-lg">
                        <div className="text-sm font-medium text-red-700 min-w-16">11:00</div>
                        <Home className="w-4 h-4 text-red-600" />
                        <div className="flex-1">
                          <p className="font-medium">Check-out</p>
                          <p className="text-sm text-gray-600">Libération villa • Inspection finale</p>
                        </div>
                        <Badge className="bg-red-100 text-red-800">Obligatoire</Badge>
                      </div>

                      <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                        <div className="text-sm font-medium text-blue-700 min-w-16">12:00</div>
                        <Car className="w-4 h-4 text-blue-600" />
                        <div className="flex-1">
                          <p className="font-medium">Transfert villa → Aéroport</p>
                          <p className="text-sm text-gray-600">Mercedes Classe S • Vol 15:30</p>
                        </div>
                        <Badge className="bg-green-100 text-green-800">Confirmé</Badge>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
              )}

              {/* Modal d'ajout d'événement */}
              {showAddEventModal && (
                <Dialog open={showAddEventModal} onOpenChange={setShowAddEventModal}>
                <DialogContent className="max-w-2xl">
                  <DialogHeader>
                    <DialogTitle>Ajouter un nouvel événement</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-6">
                    {/* Informations de base */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-sm font-medium mb-2 block">Date</label>
                        <select 
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.date}
                          onChange={(e) => setNewEvent({...newEvent, date: e.target.value})}
                        >
                          <option value="">Sélectionner une date</option>
                          <option value="2025-07-20">Dimanche 20 Juillet - Arrivée</option>
                          <option value="2025-07-21">Lundi 21 Juillet</option>
                          <option value="2025-07-22">Mardi 22 Juillet</option>
                          <option value="2025-07-23">Mercredi 23 Juillet</option>
                          <option value="2025-07-24">Jeudi 24 Juillet</option>
                          <option value="2025-07-25">Vendredi 25 Juillet</option>
                          <option value="2025-07-26">Samedi 26 Juillet</option>
                          <option value="2025-07-27">Dimanche 27 Juillet - Départ</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-sm font-medium mb-2 block">Type d'événement</label>
                        <select 
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.type}
                          onChange={(e) => setNewEvent({...newEvent, type: e.target.value})}
                        >
                          <option value="activity">Activité/Excursion</option>
                          <option value="transport">Transport</option>
                          <option value="dining">Restauration</option>
                          <option value="wellness">Wellness/Spa</option>
                          <option value="villa">Service villa</option>
                          <option value="shopping">Shopping</option>
                          <option value="culture">Culture/Visite</option>
                          <option value="other">Autre</option>
                        </select>
                      </div>
                    </div>

                    {/* Horaires */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-sm font-medium mb-2 block">Heure de début</label>
                        <input 
                          type="time"
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.time}
                          onChange={(e) => setNewEvent({...newEvent, time: e.target.value})}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium mb-2 block">Heure de fin (optionnel)</label>
                        <input 
                          type="time"
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.endTime}
                          onChange={(e) => setNewEvent({...newEvent, endTime: e.target.value})}
                        />
                      </div>
                    </div>

                    {/* Détails de l'événement */}
                    <div>
                      <label className="text-sm font-medium mb-2 block">Nom de l'événement</label>
                      <input 
                        type="text"
                        placeholder="Ex: Massage relaxant, Visite musée, Transfert aéroport..."
                        className="w-full p-2 border rounded-md text-sm"
                        value={newEvent.name}
                        onChange={(e) => setNewEvent({...newEvent, name: e.target.value})}
                      />
                    </div>

                    <div>
                      <label className="text-sm font-medium mb-2 block">Description</label>
                      <textarea 
                        placeholder="Détails sur l'événement, instructions spéciales..."
                        className="w-full p-2 border rounded-md text-sm h-20 resize-none"
                        value={newEvent.description}
                        onChange={(e) => setNewEvent({...newEvent, description: e.target.value})}
                      />
                    </div>

                    {/* Prestataire et prix */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-sm font-medium mb-2 block">Prestataire (optionnel)</label>
                        <input 
                          type="text"
                          placeholder="Nom du prestataire ou service"
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.provider}
                          onChange={(e) => setNewEvent({...newEvent, provider: e.target.value})}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium mb-2 block">Prix €  (optionnel)</label>
                        <input 
                          type="number"
                          placeholder="0"
                          className="w-full p-2 border rounded-md text-sm"
                          value={newEvent.price}
                          onChange={(e) => setNewEvent({...newEvent, price: e.target.value})}
                        />
                      </div>
                    </div>

                    {/* Statut */}
                    <div>
                      <label className="text-sm font-medium mb-2 block">Statut</label>
                      <select 
                        className="w-full p-2 border rounded-md text-sm"
                        value={newEvent.status}
                        onChange={(e) => setNewEvent({...newEvent, status: e.target.value})}
                      >
                        <option value="confirmed">Confirmé</option>
                        <option value="pending">En attente</option>
                        <option value="requested">Demandé</option>
                        <option value="cancelled">Annulé</option>
                      </select>
                    </div>

                    {/* Aperçu de l'événement */}
                    {newEvent.name && (
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <h4 className="text-sm font-medium mb-2">Aperçu de l'événement</h4>
                        <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                          <div className="text-sm font-medium text-blue-700 min-w-16">
                            {newEvent.time || '--:--'}
                          </div>
                          <div className="flex-1">
                            <p className="font-medium">{newEvent.name}</p>
                            {newEvent.description && (
                              <p className="text-sm text-gray-600">{newEvent.description}</p>
                            )}
                            {newEvent.provider && (
                              <p className="text-xs text-gray-500">Prestataire: {newEvent.provider}</p>
                            )}
                          </div>
                          {newEvent.price && (
                            <div className="text-sm font-medium">€{newEvent.price}</div>
                          )}
                          <Badge className={
                            newEvent.status === 'confirmed' ? 'bg-green-100 text-green-800' :
                            newEvent.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                            newEvent.status === 'requested' ? 'bg-blue-100 text-blue-800' :
                            'bg-red-100 text-red-800'
                          }>
                            {newEvent.status === 'confirmed' && 'Confirmé'}
                            {newEvent.status === 'pending' && 'En attente'}
                            {newEvent.status === 'requested' && 'Demandé'}
                            {newEvent.status === 'cancelled' && 'Annulé'}
                          </Badge>
                        </div>
                      </div>
                    )}

                    {/* Boutons d'action */}
                    <div className="flex justify-end space-x-3 pt-4 border-t">
                      <Button 
                        variant="outline" 
                        onClick={() => {
                          setShowAddEventModal(false);
                          setNewEvent({
                            date: '',
                            time: '',
                            endTime: '',
                            name: '',
                            description: '',
                            provider: '',
                            price: '',
                            status: 'pending',
                            type: 'activity'
                          });
                        }}
                      >
                        Annuler
                      </Button>
                      <Button 
                        className="bg-yellow-600 hover:bg-yellow-700 text-black"
                        onClick={() => {
                          // Ici on pourrait ajouter l'événement à la liste
                          console.log('Nouvel événement ajouté:', newEvent);
                          setShowAddEventModal(false);
                          setNewEvent({
                            date: '',
                            time: '',
                            endTime: '',
                            name: '',
                            description: '',
                            provider: '',
                            price: '',
                            status: 'pending',
                            type: 'activity'
                          });
                          // Afficher une notification de succès
                          alert('Événement ajouté avec succès au planning !');
                        }}
                        disabled={!newEvent.name || !newEvent.date || !newEvent.time}
                      >
                        Ajouter événement
                      </Button>
                    </div>
                  </div>
                </DialogContent>
                </Dialog>
              )}
            </div>
          </TabsContent>

          {/* Conciergerie */}
          <TabsContent value="concierge">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Services de conciergerie</h3>
                <Button className="bg-yellow-600 hover:bg-yellow-700 text-black">
                  <Plus className="w-4 h-4 mr-2" />
                  Ajouter service
                </Button>
              </div>
              
              <div className="grid gap-4">
                {reservationData.conciergeServices.map(service => (
                  <Card key={service.id}>
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-3 mb-2">
                            <h4 className="font-semibold">{service.name}</h4>
                            <Badge className={getStatusColor(service.status)}>
                              {service.status}
                            </Badge>
                          </div>
                          <p className="text-sm text-gray-600 mb-2">{service.description}</p>
                          <div className="flex items-center space-x-4 text-sm text-gray-500">
                            <div className="flex items-center space-x-1">
                              <Calendar className="w-4 h-4" />
                              <span>{service.date}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <Clock className="w-4 h-4" />
                              <span>{service.time}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <User className="w-4 h-4" />
                              <span>{service.provider}</span>
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-lg font-semibold">€{service.price}</p>
                          <div className="flex space-x-1 mt-2">
                            <Button variant="ghost" size="sm">
                              <Edit className="w-4 h-4" />
                            </Button>
                            <Button variant="ghost" size="sm">
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </TabsContent>

          {/* Paiements */}
          <TabsContent value="payments">
            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle>Historique des paiements</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {reservationData.payments.map(payment => (
                      <div key={payment.id} className="flex items-center justify-between p-4 border rounded-lg">
                        <div className="flex items-center space-x-3">
                          <div className={`w-3 h-3 rounded-full ${payment.status === 'completed' ? 'bg-green-500' : 'bg-yellow-500'}`}></div>
                          <div>
                            <p className="font-medium">{payment.description}</p>
                            <p className="text-sm text-gray-600">{formatDate(payment.date)} • {payment.method}</p>
                            <p className="text-xs text-gray-500">{payment.reference}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-lg font-semibold">€{payment.amount.toLocaleString()}</p>
                          <Badge className={getStatusColor(payment.status)}>
                            {payment.status}
                          </Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Timeline */}
          <TabsContent value="timeline">
            <Card>
              <CardHeader>
                <CardTitle>Historique de la réservation</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-6">
                  {reservationData.timeline.map((event, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className={`w-3 h-3 rounded-full mt-2 ${
                        event.status === 'success' ? 'bg-green-500' : 
                        event.status === 'warning' ? 'bg-yellow-500' : 
                        'bg-blue-500'
                      }`}></div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <h4 className="font-medium">{event.action}</h4>
                          <span className="text-sm text-gray-500">{formatDateTime(event.date)}</span>
                        </div>
                        <p className="text-sm text-gray-600">{event.description}</p>
                        <p className="text-xs text-gray-500 mt-1">par {event.user}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Documents */}
          <TabsContent value="documents">
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Documents de la réservation</h3>
                <Button variant="outline">
                  <Plus className="w-4 h-4 mr-2" />
                  Ajouter document
                </Button>
              </div>

              <div className="grid gap-4">
                {reservationData.documents.map((doc, index) => (
                  <Card key={index}>
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <FileText className="w-6 h-6 text-gray-400" />
                          <div>
                            <p className="font-medium">{doc.name}</p>
                            {doc.date && (
                              <p className="text-sm text-gray-500">Signé le {formatDate(doc.date)}</p>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center space-x-2">
                          <Badge className={getStatusColor(doc.status)}>
                            {doc.status}
                          </Badge>
                          <Button variant="ghost" size="sm">
                            <Camera className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>

              {/* Notes */}
              <Card>
                <CardHeader>
                  <CardTitle>Notes internes</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {reservationData.notes.map(note => (
                      <div key={note.id} className="p-3 bg-gray-50 rounded-lg">
                        <div className="flex justify-between items-start mb-2">
                          <span className="font-medium text-sm">{note.author}</span>
                          <span className="text-xs text-gray-500">{formatDateTime(note.date)}</span>
                        </div>
                        <p className="text-sm">{note.content}</p>
                        {note.type === 'warning' && (
                          <div className="flex items-center space-x-1 mt-2">
                            <AlertCircle className="w-4 h-4 text-yellow-500" />
                            <span className="text-xs text-yellow-600">Note importante</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default ReservationDetail;